import React, { useMemo } from 'react';
import './ReviewForecast.css';

export const ReviewForecast = ({ reviewData, allDecks }) => {
  const forecastData = useMemo(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const forecast = {
      today: 0,
      tomorrow: 0,
      next7Days: 0,
      next30Days: 0,
      byDay: []
    };

    // Generate next 30 days
    for (let i = 0; i < 30; i++) {
      const date = new Date(today);
      date.setDate(date.getDate() + i);
      forecast.byDay.push({
        date: date.toISOString().split('T')[0],
        dateObj: date,
        count: 0,
        cards: []
      });
    }

    // Count due cards per day
    Object.entries(reviewData).forEach(([key, review]) => {
      if (!review || !review.dueDate) return;

      const dueDate = new Date(review.dueDate);
      dueDate.setHours(0, 0, 0, 0);

      const dueDateStr = dueDate.toISOString().split('T')[0];
      const dayData = forecast.byDay.find(d => d.date === dueDateStr);

      if (dayData) {
        dayData.count++;

        // Get card info
        const [deckName, indexStr] = key.split('|');
        const index = parseInt(indexStr);
        if (allDecks[deckName] && allDecks[deckName][index]) {
          dayData.cards.push({
            deckName,
            card: allDecks[deckName][index]
          });
        }
      }

      // Count for summary
      const diffTime = dueDate - today;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays === 0) {
        forecast.today++;
      } else if (diffDays === 1) {
        forecast.tomorrow++;
      }

      if (diffDays >= 0 && diffDays < 7) {
        forecast.next7Days++;
      }

      if (diffDays >= 0 && diffDays < 30) {
        forecast.next30Days++;
      }
    });

    return forecast;
  }, [reviewData, allDecks]);

  const getDayLabel = (dateObj) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    if (dateObj.toISOString().split('T')[0] === today.toISOString().split('T')[0]) {
      return 'Today';
    } else if (dateObj.toISOString().split('T')[0] === tomorrow.toISOString().split('T')[0]) {
      return 'Tomorrow';
    }

    const options = { weekday: 'short', month: 'short', day: 'numeric' };
    return dateObj.toLocaleDateString('en-US', options);
  };

  const maxCount = Math.max(...forecastData.byDay.map(d => d.count), 1);

  return (
    <div className="review-forecast">
      {/* Summary Cards */}
      <div className="forecast-summary">
        <div className="forecast-card forecast-today">
          <div className="forecast-value">{forecastData.today}</div>
          <div className="forecast-label">Due Today</div>
        </div>
        <div className="forecast-card forecast-tomorrow">
          <div className="forecast-value">{forecastData.tomorrow}</div>
          <div className="forecast-label">Due Tomorrow</div>
        </div>
        <div className="forecast-card forecast-week">
          <div className="forecast-value">{forecastData.next7Days}</div>
          <div className="forecast-label">Next 7 Days</div>
        </div>
        <div className="forecast-card forecast-month">
          <div className="forecast-value">{forecastData.next30Days}</div>
          <div className="forecast-label">Next 30 Days</div>
        </div>
      </div>

      {/* Daily Forecast */}
      <div className="forecast-timeline">
        <h4>Upcoming Reviews</h4>
        <div className="forecast-days">
          {forecastData.byDay.slice(0, 14).map((day, index) => (
            <div key={day.date} className="forecast-day">
              <div className="forecast-day-header">
                <span className="forecast-day-label">{getDayLabel(day.dateObj)}</span>
                <span className="forecast-day-count">{day.count} cards</span>
              </div>
              <div className="forecast-day-bar">
                <div
                  className="forecast-day-bar-fill"
                  style={{
                    width: `${(day.count / maxCount) * 100}%`,
                    backgroundColor: index === 0 ? '#ef4444' : index === 1 ? '#f59e0b' : '#3b82f6'
                  }}
                />
              </div>
              {day.count > 0 && day.count <= 5 && (
                <div className="forecast-day-cards">
                  {day.cards.slice(0, 3).map((item, idx) => (
                    <div key={idx} className="forecast-card-preview">
                      <span className="forecast-card-deck">{item.deckName}</span>
                      <span className="forecast-card-text">{item.card.ar}</span>
                    </div>
                  ))}
                  {day.cards.length > 3 && (
                    <div className="forecast-card-more">
                      +{day.cards.length - 3} more
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
